var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.6,
    height: 27.672,
    viewBox: "0 0 30.6 27.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u041F\\u043E\\u0431\\u0430\\u0436\\u0430\\u043D\\u043D\\u044F",
    transform: "translate(0 4.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_1",
    "data-name": "Union 1",
    transform: "translate(1293.4 3963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1290.4-3940.177a3,3,0,0,1-3-3V-3960a3,3,0,0,1,3-3h14.812a6.5,6.5,0,0,1,6.289-4.85,6.5,6.5,0,0,1,6.5,6.5,6.5,6.5,0,0,1-3.7,5.869v12.3a3,3,0,0,1-3,3Z",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -1269.501342773438 -3941.177490234375 C -1268.39892578125 -3941.177490234375 -1267.501953125 -3942.07470703125 -1267.501953125 -3943.177734375 L -1267.501953125 -3955.48046875 L -1267.501953125 -3956.111083984375 L -1266.932861328125 -3956.3828125 C -1266.008544921875 -3956.82421875 -1265.226318359375 -3957.513916015625 -1264.670532226563 -3958.37744140625 C -1264.100708007813 -3959.2626953125 -1263.799560546875 -3960.290283203125 -1263.799560546875 -3961.34912109375 C -1263.799560546875 -3964.382080078125 -1266.266723632813 -3966.849609375 -1269.299194335938 -3966.849609375 C -1271.7998046875 -3966.849609375 -1273.988037109375 -3965.162353515625 -1274.620727539063 -3962.74658203125 L -1274.816284179688 -3962 L -1275.588134765625 -3962 L -1290.400146484375 -3962 C -1291.502563476563 -3962 -1292.3994140625 -3961.102783203125 -1292.3994140625 -3959.999755859375 L -1292.3994140625 -3943.177734375 C -1292.3994140625 -3942.07470703125 -1291.502563476563 -3941.177490234375 -1290.400146484375 -3941.177490234375 L -1269.501342773438 -3941.177490234375 M -1269.501342773438 -3940.177490234375 L -1290.400146484375 -3940.177490234375 C -1292.05615234375 -3940.177490234375 -1293.3994140625 -3941.520751953125 -1293.3994140625 -3943.177734375 L -1293.3994140625 -3959.999755859375 C -1293.3994140625 -3961.65673828125 -1292.05615234375 -3963 -1290.400146484375 -3963 L -1275.588134765625 -3963 C -1274.857299804688 -3965.79052734375 -1272.318481445313 -3967.849609375 -1269.299194335938 -3967.849609375 C -1265.709228515625 -3967.849609375 -1262.799560546875 -3964.93896484375 -1262.799560546875 -3961.34912109375 C -1262.799560546875 -3958.7607421875 -1264.312377929688 -3956.52587890625 -1266.501953125 -3955.48046875 L -1266.501953125 -3943.177734375 C -1266.501953125 -3941.520751953125 -1267.84423828125 -3940.177490234375 -1269.501342773438 -3940.177490234375 Z",
    stroke: "none",
    fill: "current"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_355",
    "data-name": "Rectangle 355",
    width: 8.966,
    height: 1,
    rx: 0.5,
    transform: "translate(5.706 7.336)",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 15.487,
    height: 1,
    rx: 0.5,
    transform: "translate(5.706 11.411)",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_357",
    "data-name": "Rectangle 357",
    width: 15.487,
    height: 1,
    rx: 0.5,
    transform: "translate(5.706 15.487)",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    transform: "translate(17.6 -4.849)",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 5.95,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M21.193.507l2.272,3.3,3.849-4.84",
    fill: "none",
    stroke: "current",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.2cd405faa43254bdfc0919543019bb98.svg";
export { ForwardRef as ReactComponent };